"use strict";
/**
 * oneAudi OS React
 * @copyright (c) Audi Business Innovation GmbH
 * @license Private
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSSR = exports.FeatureLoader = exports.FeatureAppLoader = exports.preloadFeatureApps = exports.onFeaturesReady = exports.FeatureAppModel = exports.useInternalMetaData = exports.ErrorBoundary = exports.useAnotherAppState = exports.useDocument = exports.useAppState = exports.App = exports.Provider = void 0;
var Provider_1 = require("./Provider");
Object.defineProperty(exports, "Provider", { enumerable: true, get: function () { return Provider_1.Provider; } });
var App_1 = require("./App");
Object.defineProperty(exports, "App", { enumerable: true, get: function () { return App_1.App; } });
var useAppState_1 = require("./useAppState");
Object.defineProperty(exports, "useAppState", { enumerable: true, get: function () { return useAppState_1.useAppState; } });
var useDocument_1 = require("./useDocument");
Object.defineProperty(exports, "useDocument", { enumerable: true, get: function () { return useDocument_1.useDocument; } });
var useAnotherAppState_1 = require("./useAnotherAppState");
Object.defineProperty(exports, "useAnotherAppState", { enumerable: true, get: function () { return useAnotherAppState_1.useAnotherAppState; } });
var ErrorBoundary_1 = require("./ErrorBoundary");
Object.defineProperty(exports, "ErrorBoundary", { enumerable: true, get: function () { return ErrorBoundary_1.ErrorBoundary; } });
__exportStar(require("./Hypervisor"), exports);
var useInternalMetaData_1 = require("./useInternalMetaData");
Object.defineProperty(exports, "useInternalMetaData", { enumerable: true, get: function () { return useInternalMetaData_1.useInternalMetaData; } });
var FeatureAppModel_1 = require("./FeatureAppModel");
Object.defineProperty(exports, "FeatureAppModel", { enumerable: true, get: function () { return FeatureAppModel_1.FeatureAppModel; } });
var FeatureAppLoader_1 = require("./FeatureAppLoader");
Object.defineProperty(exports, "onFeaturesReady", { enumerable: true, get: function () { return FeatureAppLoader_1.onFeaturesReady; } });
Object.defineProperty(exports, "preloadFeatureApps", { enumerable: true, get: function () { return FeatureAppLoader_1.preloadFeatureApps; } });
Object.defineProperty(exports, "FeatureAppLoader", { enumerable: true, get: function () { return FeatureAppLoader_1.FeatureAppLoader; } });
/** @deprecated aliases for FeatureAppLoader */
Object.defineProperty(exports, "FeatureLoader", { enumerable: true, get: function () { return FeatureAppLoader_1.FeatureAppLoader; } });
var oneaudi_os_utils_1 = require("@oneaudi/oneaudi-os-utils");
Object.defineProperty(exports, "isSSR", { enumerable: true, get: function () { return oneaudi_os_utils_1.isSSR; } });
require("./interfaces");
// Disabled for node.js support, but keeping here because sourcemaps will see the signature.
// Make the current package version available (s.a script release:write-version in package.json)
// self.version = 'x.x.x-SNAPSHOT';
